<template>
  <div>
    <div class="row col-lg-12 m-b-sm">
      <div class="col-lg-3">
        <v-select
          :options="f.clients"
          label="name" index="id" multiple
          v-model="filters['clients']"
          @input="loadOrders"
          placeholder="Clients"></v-select>
      </div>
      <div class="col-lg-3">
        <v-select
          :options="statuses"
          v-model="filters['status']"
          multiple
          placeholder="Status"
          @input="loadOrders"
        ></v-select>
      </div>
    </div>
    <table class="table table-hover">
      <thead>
      <tr>
        <th>Domain</th>
        <th>Requested</th>
        <th>Cutoff Time</th>
        <th>Client</th>
        <th>Status</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="domain in domains" :key="domain.id">
        <td>{{ domain.domain }}</td>
        <td>{{ domain.added | aTime('DD.MM.YYYY') }}</td>
        <td>{{ domain.cutoffTime | aTime('DD.MM.YYYY') }}</td>
        <td>{{ domain.order ? domain.order.client.name : '/' }}</td>
        <td>{{ domain.status }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Query } from '../../../../mixins/helperMixin'

export default {
  data () {
    return {
      domains: [],
      filters: {},
      statuses: ['Active', 'Success', 'Failed', 'Auction']
    }
  },
  mounted () {
    this.loadOrders()
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    document.title = 'Domain Backorders :: PBN360 by Aphex Media'
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mixins: [Query],
  methods: {
    loadOrders () {
      axios.get('/domains/backorders?' + this.buildQuery(this.filters))
        .then(r => {
          this.domains = r.data.data
        })
        .catch()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Domains/BackordersTab.vue